import React from 'react';
import { Link } from 'react-router';
import { Helmet } from '@dr.pogodin/react-helmet';
import dayjs from 'dayjs';

import Main from '../layouts/Main';
import posts from '../data/looseleafs';

const Looseleafs = () => (
  <Main>
    <Helmet title="Looseleafs" />
    <article className="post" id="looseleafs">
      <header>
        <div className="title">
          <h2><Link to="/looseleafs">Looseleafs</Link></h2>
          <p>Notes on data engineering, HPC, and whatever broke this week.</p>
        </div>
      </header>

      {posts.length === 0 ? (
        <p>Nothing published yet.</p>
      ) : (
        <div className="looseleaf-list">
          {posts.map((post) => (
            <article className="looseleaf-entry" key={post.slug}>
              <h3>
                <Link to={`/looseleafs/${post.slug}`}>{post.title}</Link>
              </h3>
              <time className="published" dateTime={post.date}>
                {dayjs(post.date).format('MMMM D, YYYY')}
              </time>
              {post.summary ? <p>{post.summary}</p> : null}
            </article>
          ))}
        </div>
      )}
    </article>
  </Main>
);

export default Looseleafs;
